import React, { lazy, Suspense, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Routes, Route, useNavigate } from 'react-router-dom';
import Base from '../pages/Base';
import CategoryRouteHandler from '../pages/others/CategoryRouteHandler';
import { allLinks, checkUserIsCustomer, checkUserIsSeller, checkUserIsLoginToSaveRedirectLink } from '../utils/helpers';
import ProductDetail from '../pages/customer/store/ProductDetails';
import Cart from '../pages/customer/store/Cart';
import Checkout from '../pages/customer/store/Checkout';
import PaymentStatus from '../pages/customer/store/PaymentStatus';
import StoreSeller from '../pages/seller/store/StoreSeller';
import SellerInfo from '../pages/seller/create_store/SellerInfo';
import CreateOrUpdateProduct from '../pages/seller/product/CreateOrUpdateProduct';
import ProductImports from '../pages/seller/product/ProductImports';
import OrderSeller from '../pages/seller/order/OrderSeller';
import OrderCustomer from '../pages/customer/store/order/OrderCustomer';
import HomeSeller from '../pages/seller/home/HomeSeller';
import Address from '../pages/address/Address';
import PageNotFound from '../pages/others/PageNotFound';
import CategoryPage from '../pages/customer/store/CategoryPage';
import SearchPage from '../pages/customer/store/SearchPage';

const Login = lazy(() => import('../pages/auth/Login'));
const ConfirmOtp = lazy(() => import('../pages/auth/ConfirmOtp'));
const AddRequest = lazy(() => import('../pages/customer/add_request/AddRequestNew'));
const Setting = lazy(() => import('../pages/setting/SettingNew'));
const Profile = lazy(() => import('../pages/profile/Profile'));

function RedirectToLogin({ redirectLink }) {
  const navigate = useNavigate();

  useEffect(() => {
    checkUserIsLoginToSaveRedirectLink(null, redirectLink);
    navigate(`/${allLinks[0]}`, { replace: true });
  }, [redirectLink, navigate]);

  return null;
}

export default function AppRoutes({ userProfile, domainComponent }) {
  return (
    <Suspense fallback={null}>
      <Routes>
        <Route path={`/${allLinks[0]}`} element={<Login />} />
        <Route path={`/${allLinks[1]}`} element={<ConfirmOtp />} />
        <Route element={<Base />}>
          {userProfile === null && (
            <>
              <Route path={`/${allLinks[2]}`} index element={domainComponent} />
              <Route
                path={`/${allLinks[3]}`}
                element={<RedirectToLogin redirectLink={`/${allLinks[3]}`} />}
              />
              <Route path={`/${allLinks[5]}/:slug`} element={<ProductDetail />} />
              <Route path={`/${allLinks[6]}`} element={<Cart />} />
              <Route path={`/${allLinks[7]}`} element={<Checkout />} />
              <Route path={`/${allLinks[18]}/:slug`} element={<CategoryPage />} />
              <Route path={`/${allLinks[19]}/:term`} element={<SearchPage />} />
            </>
          )}

          {checkUserIsCustomer(userProfile) && (
            <>
              <Route path={`/${allLinks[2]}`} index element={domainComponent} />
              <Route path={`/${allLinks[3]}`} element={<AddRequest />} />
              <Route path={`/${allLinks[5]}/:slug`} element={<ProductDetail />} />
              <Route path={`/${allLinks[6]}`} element={<Cart />} />
              <Route path={`/${allLinks[7]}`} element={<Checkout />} />
              <Route path={`/${allLinks[8]}`} element={<Address />} />
              <Route path={`/${allLinks[12]}`} element={<PaymentStatus />} />
              <Route path={`/${allLinks[15]}`} element={<OrderCustomer />} />
              <Route path={`/${allLinks[18]}/:slug`} element={<CategoryPage />} />
              <Route path={`/${allLinks[19]}/:term`} element={<SearchPage />} />

            </>
          )}

          {checkUserIsSeller(userProfile) && (
            <>
              <Route path={`/${allLinks[2]}`} index element={<HomeSeller />} />
              <Route path={`/${allLinks[4]}`} element={<StoreSeller />} />
              <Route path={`/${allLinks[16]}`} element={<CreateOrUpdateProduct />} />
              <Route path={`/${allLinks[17]}/:id`} element={<CreateOrUpdateProduct />} />
              <Route path={`/${allLinks[8]}`} element={<Address />} />
              <Route path={`/${allLinks[13]}`} element={<SellerInfo />} />
              <Route path={`/${allLinks[14]}`} element={<OrderSeller />} />
              <Route path={`/${allLinks[20]}`} element={<ProductImports />} />
            </>
          )}

          <Route path={`/${allLinks[10]}`} element={<Profile />} />

          <Route path={`/${allLinks[9]}`} element={<Setting />} />

          {/* Handle unknown routes by checking category slugs */}
          <Route path="*" element={<PageNotFound />} />
        </Route>
      </Routes>
    </Suspense>
  );
}

AppRoutes.propTypes = {
  userProfile: PropTypes.any,
  domainComponent: PropTypes.node,
};
